import { publicModeUrl, fetchPublicResult, setGridStyle, displayGridInfo, displayServiceGridInfo, displaySupplierGridInfo } from '../common.js';

const urlParams = new URLSearchParams(location.search);
const params = Object.fromEntries(urlParams);
let type = "product";
if (params.type) { type = params.type; };

setGridStyle(params.showSupplierName, params.isImageOnly, params.backgroundColor, params.titleColor, params.textColor, type);
let url = new URL(publicModeUrl + params.ad_id + "/items/" + params.urn);
let fetch_params = {
	urn: params.urn,
	locale: params.locale
};
Object.keys(fetch_params).forEach(key => url.searchParams.append(key, fetch_params[key]));
fetchPublicResult(url)
	.then(jsonData => {
		switch (type) {
			case "product":
				if (jsonData.data.items) {
					displayGridInfo(jsonData.data.items[0]);
				}
				break;
			
			case "service":
				if (jsonData.data.items) {
					displayServiceGridInfo(jsonData.data.items[0]);
				}
			break;

			case "supplier":
				if (jsonData.data.items) {
					displaySupplierGridInfo(jsonData.data.items[0], params.showSupplierName);
				}
			break;
		
			default:
				break;
		}
});